import { render, staticRenderFns } from "./SubmitSuccess.vue?vue&type=template&id=82839cca&scoped=true"
import script from "./SubmitSuccess.vue?vue&type=script&lang=js"
export * from "./SubmitSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82839cca",
  null
  
)

export default component.exports